<template>
    <nav class="navbar navbar-expand-lg navbar-light fixed-top bg-white">
        <div class="container">
            <a class="navbar-brand" href="/">
                <img class="" style="width: 1.5em;" :src="require('@/assets/svg/logos/short_mhi.svg')" alt="MHIsystems.com"> 
                <span class="text-secondary fw-normal ms-1" style="font-size: .9em;">MHIsystems.com</span>
            </a>
            <!--a class="navbar-brand lora" href="../index.html">MHIsystems.com</a-->
            <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse" id="navbarCollapse">

                <ul class="navbar-nav ms-auto mb-2 mb-md-0">
                    <li class="nav-item"><a href="https://www.mhisystems.com/index.html#IntakeForm" class="nav-link">Intake Form</a></li>
                    <li class="nav-item"><a href="https://www.mhisystems.com/index.html#SelectiveAssessment" class="nav-link">Selective Assessment</a></li>
                    <li class="nav-item"><a href="https://www.mhisystems.com/index.html#ProviderOffice" class="nav-link">Provider Office</a></li>
                    <li class="nav-item"><a href="https://www.mhisystems.com/index.html#Pricing" class="nav-link">Pricing</a></li>
                    <li class="nav-item"><a href="https://www.mhisystems.com/index.html#MHIFuture" class="nav-link">MHI's Future</a></li>
                    <li class="nav-item"><router-link :to="'/register/patient'" class="btn btn-sm btn-outline-success me-2">Sign Up</router-link></li>
                    <li class="nav-item"><router-link :to="'/'" class="btn btn-sm btn-outline-success">Login</router-link></li>
                </ul>

            </div>
        </div>
    </nav>
</template>
<script>
    export default {
        name: 'MHIHeader',
    }
</script>